import { RouterModule, Routes } from '@angular/router';
import { WebdokuPageComponent } from './web-doku/webdoku/webdoku-page.component';
import { SettingsPageComponent } from './shell/settings/settings-page.component';
import { DocumentNavigationPageComponent } from './documents/document-navigation/document-navigation-page.component';
import { BasicNavigationPageComponent } from './documents/basic-navigation/basic-navigation-page.component';
import { ScanPageComponent } from './search/scan/scan-page.component';
import { SearchPageComponent } from './search/search/search-page.component';
import { NeedWebDokuGuard } from './route/need-web-doku.guard';
import { CheckChangesGuard } from './route/check-changes.guard';
import { DocumentHistoryPageComponent } from './documents/document-history/document-history-page.component';
import { DocumentEditPageComponent } from './documents/document-edit/document-edit-page.component';
import { NoWebdokuPageComponent } from './web-doku/no-webdoku/no-webdoku-page.component';
import { DocumentInfoPageComponent } from './documents/document-info/document-info-page.component';
import { DocumentChangesPageComponent } from './documents/document-changes/document-changes-page.component';
import { DocumentCopyPageComponent } from './documents/document-copy/document-copy-page.component';
import { DocumentViewPageComponent } from './documents/document-view/document-view-page.component';
import { DocumentHistoryDetailPageComponent } from './documents/document-history-detail/document-history-detail-page.component';
import { AuthGuardWithForcedLogin } from './route/auth/auth-guard-with-forced-login.service';
import { LogOutComponent } from './shell/log-out/log-out.component';
import { MainNavigationComponent } from './shell/main-navigation.component';
import { DocumentDetailResolver } from './documents/document-detail.resolver';
import { InfoChangedComponent } from './info/info-changed/info-changed.component';
import { InfoWebdokuComponent } from './info/info-webdoku/info-webdoku.component';
import { InfoHistoryComponent } from './info/info-history/info-history.component';
import { DocumentHistoryResolver } from './documents/document-history.resolver';
import { MessagesPageComponent } from './shell/messages/messages-page.component';
import { ErrorPageComponent } from './shell/error-page/error-page.component';
import { LinkComponent } from './perma/link.component';
import { DocSearchComponent } from './perma/docsearch.component';
import { DocTreeSearchComponent } from './perma/doctreesearch.component';
import { PltTreeSearchComponent } from './perma/plttreesearch.component';
import { ManualPageComponent } from './shell/manual/manual-page.component';
import { authGuard } from './route/auth/auth-guard';
import { DocumentCopyDataResolver } from './documents/document-copydata.resolver';
import { CustomNavigationPageComponent } from './documents/custom-navigation/custom-navigation-page.component';
import { CustomTreeSearchComponent } from './perma/customtreesearch.component';
import { AuthFailedComponent } from './shell/auth-failed/auth-failed.component';
import { LoginComponent } from './shell/login/login.component';
import { translateTitle } from './route/translated-title.resolver';

/* Attention: route names are used as ids for translation
 *            see assets/i18n => de.json/en.json
 */

export const routeWebDoku = 'webdoku';
export const routeDocumentNavigation = 'documentnavigation';
export const routeBasicNavigation = 'basicnavigation';
export const routeCustomNavigation = 'customnavigation';
export const routeInfoChanged = 'wdchanges';
export const routeInfoHistory = 'infohistory';
export const routeInfoWebDoku = 'wdinfo';
export const routeScan = 'scan';
export const routeSearch = 'search';
export const routeSettings = 'settings';
export const routeMessages = 'messages';
export const routeLogoff = 'logoff';
export const routeLogin = 'login';
export const routeError = 'error';
export const routeAuthFailed = 'auth-failed';
export const routeDocumentEdit = 'docedit';
export const routeDocumentView = 'docview';
export const routeDocumentHistory = 'dochistory';
export const routeDocumentHistoryView = 'dochistoryview';
export const routeDocumentInfo = 'docinfo';
export const routeDocumentChanges = 'docchanges';
export const routeDocumentCopy = 'doccopy';
export const routeNoWebDokusAvailable = 'nowebdoku';
export const routePermaSearchDoc = 'rddocsearch';
export const routePermaSearchDocTree = 'rddoctreesearch';
export const routePermaSearchPLTTree = 'rdplttreesearch';
export const routePermaSearchCustomTree = 'rdcustomtreesearch';
export const routePermaLink = 'rdlink';
export const routeManual = 'manual';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuardWithForcedLogin],
    component: MainNavigationComponent,
    children: [
      {
        path: '',
        redirectTo: routeWebDoku,
        pathMatch: 'full',
      },
      {
        path: routeWebDoku,
        component: WebdokuPageComponent,
        title: translateTitle,
        data: {
          titleKey: 'COMMANDS.WEBDOKU'
        }
      },
      {
        path: `${routeDocumentNavigation}/:wd`,
        component: DocumentNavigationPageComponent,
        title: translateTitle,
        data: {
          titleKey: 'COMMANDS.DOCUMENTNAVIGATION'
        }
        //// NeedWebDoku bases on required wd-Parameter
        // canActivate: [NeedWebDokuGuard],
      },
      {
        path: `${routeBasicNavigation}/:wd`,
        component: BasicNavigationPageComponent,
        title: translateTitle,
        data: {
          titleKey: 'COMMANDS.BASICNAVIGATION'
        }
        // canActivate: [NeedWebDokuGuard],
      },
      {
        path: `${routeCustomNavigation}/:wd`,
        component: CustomNavigationPageComponent,
        title: translateTitle,
        data: {
          titleKey: 'COMMANDS.CUSTOMNAVIGATION'
        }
        // canActivate: [NeedWebDokuGuard],
      },
      {
        path: `${routeInfoHistory}/:wd`,
        component: InfoHistoryComponent,
        title: translateTitle,
        data: {
          titleKey: 'COMMANDS.INFOHISTORY'
        }
        // canActivate: [NeedWebDokuGuard],
      },
      {
        path: `${routeInfoChanged}/:wd`,
        component: InfoChangedComponent,
        title: translateTitle,
        data: {
          titleKey: 'COMMANDS.WDCHANGES'
        }
        // canActivate: [NeedWebDokuGuard],
      },
      {
        path: `${routeInfoWebDoku}/:wd`,
        component: InfoWebdokuComponent,
        title: translateTitle,
        data: {
          titleKey: 'COMMANDS.WDINFO'
        }
        // canActivate: [NeedWebDokuGuard],
      },

      {
        path: routeScan,
        component: ScanPageComponent,
        canActivate: [NeedWebDokuGuard],

      },
      {
        path: `${routeSearch}/:wd`,
        component: SearchPageComponent,
        // canActivate: [NeedWebDokuGuard],
        title: translateTitle,
        data: {
          titleKey: 'COMMANDS.SEARCH'
        }
      },
      {
        path: `${routeDocumentView}/:wd/:docid`,
        component: DocumentViewPageComponent,
        resolve: { document: DocumentDetailResolver },
        // canActivate: [NeedWebDokuGuard],
      },
      {
        path: `${routeDocumentEdit}/:wd/:docid`,
        component: DocumentEditPageComponent,
        resolve: { document: DocumentDetailResolver },
        canDeactivate: [CheckChangesGuard],
        // canActivate: [NeedWebDokuGuard],
      },
      {
        path: `${routeDocumentHistory}/:wd/:docid`,
        component: DocumentHistoryPageComponent,
        resolve: { document: DocumentDetailResolver, history: DocumentHistoryResolver },
        // canActivate: [NeedWebDokuGuard],
      },
      {
        path: `${routeDocumentHistoryView}/:wd/:docid`,
        component: DocumentHistoryDetailPageComponent,
        resolve: { document: DocumentDetailResolver, history: DocumentHistoryResolver },
        // canActivate: [NeedWebDokuGuard],
      },
      {
        path: routeDocumentInfo,
        component: DocumentInfoPageComponent,
        canActivate: [NeedWebDokuGuard],
      },
      {
        path: routeDocumentChanges,
        component: DocumentChangesPageComponent,
        canActivate: [NeedWebDokuGuard],
      },
      {
        path: routeDocumentCopy,
        component: DocumentCopyPageComponent,
        resolve: { document: DocumentDetailResolver, copyData: DocumentCopyDataResolver },
        // canActivate: [NeedWebDokuGuard],
      },
      {
        path: routeSettings,
        component: SettingsPageComponent,
        canActivate: [authGuard],
        title: translateTitle,
        data: {
          titleKey: 'COMMANDS.USER'
        }
      },
      {
        path: routeMessages,
        component: MessagesPageComponent,
        canActivate: [authGuard],
      },
      /*
      {
        path: routeLogoff,
        component: SettingsPageComponent,
        pathMatch: 'full',
        canActivate: [AuthGuard],
      },
       */
      {
        path: routeNoWebDokusAvailable,
        component: NoWebdokuPageComponent,
        canActivate: [authGuard],
      },
      {
        path: routeManual, component: ManualPageComponent, title: translateTitle,
        data: {
          titleKey: 'COMMANDS.MANUAL'
        }
      },
      { path: routePermaLink, component: LinkComponent },
      { path: routePermaSearchDoc, component: DocSearchComponent },
      { path: routePermaSearchDocTree, component: DocTreeSearchComponent },
      { path: routePermaSearchPLTTree, component: PltTreeSearchComponent },
      { path: routePermaSearchCustomTree, component: CustomTreeSearchComponent },
    ],
  },
  { path: routeLogin, component: LoginComponent },
  { path: routeLogoff, component: LogOutComponent, pathMatch: 'full' },
  { path: routeError, component: ErrorPageComponent },
  { path: routeAuthFailed, component: AuthFailedComponent },
];

export const LivedokwebRouting = RouterModule.forRoot(routes, {
  enableTracing: false,
  anchorScrolling: 'disabled',
  scrollPositionRestoration: 'disabled',
});
